import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import ImageVideoResourceComponent from './src/@husky-x/gatsby-theme-husky/components/ImageVideoResourceComponent';
import ImageInteractiveComponent from './src/@husky-x/gatsby-theme-husky/components/ImageInteractiveComponent';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'ImageVideoResourceComponent',
        component: ImageVideoResourceComponent,
      },
      {
        key: 'ImageInteractiveComponent',
        component: ImageInteractiveComponent,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
